import PropTypes from 'prop-types'
import React, { useState } from 'react'
import FileListTable from '../FileListTable'
import { get } from 'lodash'
import { useLocation } from 'react-router-dom'
import '../../styles/item/ItemFiles.scss'
import Uppy from '@uppy/core'
import { DashboardModal, StatusBar, ProgressBar } from '@uppy/react'
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import '@uppy/progress-bar/dist/style.css'
import '@uppy/status-bar/dist/style.css'

import { Modal, Button } from 'react-bootstrap'
import DeletedFileTable from '../DeletedFileTable'

const AwsS3Multipart = require('@uppy/aws-s3-multipart')

export default function ItemFiles({
  item,
  queryVariables,
  selectedRows,
  addChanges,
  deletedFiles,
  distributionLinks,
}) {
  const [show, setShow] = useState(false)
  const reload = () => window.location.reload()

  const UPPY_RETRY_AFTER_IN_SEC = [0, 5000, 10000, 30000, 60000, 120000]

  const handleClose = () => {
    setShow(false)
    reload()
  }

  const handleCloseUppyModal = () => {
    const uppyState = uppy.getState()
    let displayModalMessageForLaterScraping = false
    for (const [, value] of Object.entries(uppyState.files)) {
      if (value?.progress?.uploadComplete) {
        displayModalMessageForLaterScraping = true
      }
    }
    setShow(displayModalMessageForLaterScraping)
    const dashboardModelPlugin = uppy.getPlugin('dashboardModalId')

    if (dashboardModelPlugin && dashboardModelPlugin.isModalOpen()) {
      dashboardModelPlugin.closeModal()
    }
  }
  const location = useLocation()
  const fileConnection = get(item, 'fileConnection', {})
  const itemId = item.id
  const canWrite = get(item, 'permissions.currentUser.canWrite', false)
  let upload_file_dict = {}

  const uppy = new Uppy({
    id: 'sb-s3-multipart',
    autoProceed: false,
    debug: false,
    showProgressDetails: true,
    doneButtonHandler: null,
    hideUploadButton: true,
    onBeforeFileAdded: (currentFile, files) => {
      const modifiedFile = {
        ...currentFile,
        name: `${itemId}/` + currentFile.name,
      }
      return modifiedFile
    },
  })

  uppy
    .use(AwsS3Multipart, {
      companionUrl: `${process.env.REACT_APP_UPPY_COMPANION_SERVER}`,
    })
    .on('upload-error', (file, error, response) => {
      const currentRetryValue = upload_file_dict[file.id]
        ? upload_file_dict[file.id]
        : 0

      if (currentRetryValue < UPPY_RETRY_AFTER_IN_SEC.length) {
        setTimeout(function () {
          console.log(
            'Retrying File :',
            file.id,
            'retrying in',
            UPPY_RETRY_AFTER_IN_SEC[currentRetryValue]
          )
          uppy.retryUpload(file.id)
        }, UPPY_RETRY_AFTER_IN_SEC[currentRetryValue])
        upload_file_dict[file.id] = currentRetryValue + 1
      }
    })
    .on('complete', (result) => {
      console.log(result)
      console.log(
        'Upload complete! We’ve uploaded these files:',
        result.successful
      )
    })

  return (
    <div>
      <ProgressBar uppy={uppy} hideAfterFinish />
      <StatusBar
        uppy={uppy}
        showProgressDetails
        hideUploadButton
        hideAfterFinish
        doneButtonHandler={null}
      />
      <DashboardModal
        id="dashboardModalId"
        // trigger="#pick-files"
        uppy={uppy}
        onRequestClose={handleCloseUppyModal}
      />
      <FileListTable
        location={location}
        fileConnection={fileConnection}
        queryVariables={queryVariables}
        itemId={itemId}
        canWrite={canWrite}
        selectedRows={selectedRows}
        addChanges={addChanges}
        distributionLinks={distributionLinks}
      />

      {deletedFiles.length > 0 ? (
        <>
          <br />
          <br />
          <br />
          <h4>
            <span className="text-secondary font-weight-bold">
              <font color="#2471A3">{deletedFiles.length} Deleted files</font>
            </span>
          </h4>
          <DeletedFileTable
            location={location}
            deletedFiles={deletedFiles}
            queryVariables={queryVariables}
            itemId={itemId}
            selectedRows={selectedRows}
            addChanges={addChanges}
          />
        </>
      ) : (
        <></>
      )}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>File Upload Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Files uploaded will be scraped and will appear once scraped
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

ItemFiles.propTypes = {
  selectedRows: PropTypes.any,
  addChanges: PropTypes.func,
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
  childItems: PropTypes.any,
  fileConnection: PropTypes.any,
  queryVariables: PropTypes.any,
  itemId: PropTypes.string,
  summary: PropTypes.string,
  item: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    subTitle: PropTypes.string,
    fullAncestors: PropTypes.array,
    childItems: PropTypes.any,
    permissions: PropTypes.shape({
      currentUser: PropTypes.shape({
        canWrite: PropTypes.bool,
      }),
    }),
  }),
  deletedFiles: PropTypes.array,
  distributionLinks: PropTypes.array,
}
